(() => {
  const nativePlay = HTMLMediaElement.prototype.play;

  const probe = document.createElement('video');
  const supportsHls = !!probe.canPlayType('application/vnd.apple.mpegurl');

  const resolveSrc = (video) => {
    const hls = video.dataset.srcHls;
    return (supportsHls && hls) || video.dataset.src || hls;
  };

  const attachSource = (video) => {
    if (video.dataset.lazyVideoLoaded === 'true') return;
    const src = resolveSrc(video);
    if (!src) return;
    video.dataset.lazyVideoLoaded = 'true';

    // canPlayType reports "maybe" for HLS in browsers that cannot actually decode it,
    // so the mp4 fallback is wired to the error event rather than to feature detection.
    if (src === video.dataset.srcHls && video.dataset.src) {
      video.addEventListener(
        'error',
        () => {
          video.src = video.dataset.src;
          video.load();
          if (video.dataset.autoplay === 'true') video.play();
        },
        { once: true }
      );
    }

    video.src = src;
    video.load();
  };

  const prepare = (video) => {
    if (video.dataset.lazyVideoReady === 'true') return;
    video.dataset.lazyVideoReady = 'true';

    // play() rejects with AbortError whenever a pause() lands before the promise settles.
    // Theme modules call play() without a handler, so the rejection surfaces as a console error.
    video.play = function play() {
      attachSource(this);
      return nativePlay.call(this).catch((error) => {
        if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
          console.warn('lazy-video:', error);
        }
      });
    };
  };

  const activate = (video) => {
    attachSource(video);
    if (video.dataset.autoplay === 'true') video.play();
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, instance) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              instance.unobserve(entry.target);
              activate(entry.target);
            });
          },
          { rootMargin: '200px' }
        )
      : null;

  const register = (root) => {
    (root || document).querySelectorAll('video[data-lazy-video]').forEach((video) => {
      if (video.dataset.lazyVideoObserved === 'true') return;
      video.dataset.lazyVideoObserved = 'true';
      prepare(video);
      if (observer) {
        observer.observe(video);
      } else {
        activate(video);
      }
    });
  };

  register();
  document.addEventListener('shopify:section:load', (event) => register(event.target));
})();
